var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isSupport
    ? _c("div", {}, [_vm._m(0)])
    : _c("div", { staticClass: "map-container" }, [
        _c(
          "div",
          {
            staticClass: "map-viewer",
            class: {
              "sidebar-left-show": _vm.sidebar_count.left_count > 0,
              "sidebar-right-show": _vm.sidebar_count.right_count > 0,
            },
          },
          [
            _c("div", { ref: "mapContainer", staticClass: "map-content" }),
            !_vm.dragIdCustom
              ? [
                  _c("div", {
                    staticClass: "right-bottom-container",
                    attrs: { id: _vm.rightBottomTo },
                  }),
                  _c("div", {
                    staticClass: "left-bottom-container",
                    attrs: { id: _vm.leftBottomTo },
                  }),
                  _c("div", {
                    staticClass: "right-top-container",
                    attrs: { id: _vm.rightTopTo },
                  }),
                  _c("div", {
                    staticClass: "left-top-container",
                    attrs: { id: _vm.leftTopTo },
                  }),
                  _c(
                    "draggable-container",
                    {
                      staticClass: "drag-container",
                      on: {
                        "init-done": _vm.onDragInitDone,
                        "show-count:side-bar": _vm.onChangeSidebar,
                      },
                    },
                    [_c("div", { attrs: { id: _vm.draggableTo } })]
                  ),
                ]
              : _vm._e(),
            _vm.loaded ? _vm._t("default") : _vm._e(),
          ],
          2
        ),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "not-support-map" }, [
      _c("p", {}, [
        _vm._v(
          " Trình duyệt của bạn không hỗ trợ hiển thị bản đồ, vui lòng đổi trình duyệt hoặc cập nhật bản mới để xem. "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }